import { css } from '@emotion/react'
import LaunchIcon from '@mui/icons-material/Launch'
import { colors } from '@global/constants'
import { t } from '@lingui/core/macro'

const helpText = css`
  color: ${colors.gray.dark};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`

const linkText = css`
  cursor: pointer;
  margin-top: 5px;
  margin-left: 5px;
`

interface MappingHelpTextProps {
  integration: string
  redirectPath: string
}

export const MappingHelpText = ({ redirectPath }: MappingHelpTextProps) => {
  return (
    <div css={helpText}>
      <span>{t`Learn more`}</span>
      <a href={redirectPath} target="_blank" css={linkText} rel="noreferrer">
        <LaunchIcon style={{ marginLeft: 5, width: 20, height: 20 }} />
      </a>
    </div>
  )
}
